export default __webpack_public_path__ + "static/media/image11.cf420e35.jpg";